// @flow
import STEP_TYPE from '../../../constants/stepType'
import VEHICLE_TYPE from '../../../constants/vehicleType'
import buildDetailedLocation from './detailedLocation'

// Types
import type { Step } from '../../../models/step'
import type { PrebookWalkStep } from '../../../api_types'

// Constants
const WALK_SPEED = 1.25 // meters per second
const WALK_VEHICLE = {
  type: {
    id: VEHICLE_TYPE.WALK,
    key: 'walk',
    name: 'walk',
  },
  maxPassengers: 1,
  maxBags: 1,
  isMaxBagsPerPerson: true,
  imageUrl: '',
  numVehicles: 0,
  totalBags: 1,
  make: '',
  model: '',
  vehicleClass: null,
  vehicleClassName: '',
}
const WALK_PROVIDER = {
  logoUrl: '',
  email: '',
  phoneNumber: '',
  name: 'walking',
  realName: 'walking',
  rating: 5,
  ratingFloat: 5,
  ratingCount: 5,
  supplierScore: -1,
}
const WALK_BOOKING_DETAILS = {
  gratuityIncluded: true,
  tollsIncluded: true,
  meetAndGreetDefault: false,
  meetAndGreetAvailable: false,
  meetAndGreetPrice: '',
  meetAndGreetRawPrice: 0,
  cancellationPolicy: [],
  cancellableOffline: false,
  cancellableOnline: true,
  amendable: false,
  waitTime: 0,
  extraPaxRequired: false,
  acceptsGratuity: false,
  showFlightInfo: false,
  areTermsInternal: false,
  termsOfServiceURL: '',
  notes: '',
  isBookable: false,
  startTime: null,
  endTime: null,
  showTollsAndGratuity: false,
  startAddressIncomplete: false,
  endAddressIncomplete: false,
  specialInstructionsPlaceholder: '',
  hourlyDetails: null,
}

/**
 * Build Step object for walking trip step
 * @param  {PrebookWalkStep}  step
 * @param  {PartialResponse}  response
 * @return {Step}
 */
function buildWalkingStep(step: PrebookWalkStep): Step {
  const accurateTime = step.details.time_seconds
    ? Math.ceil(step.details.time_seconds / 60)
    : Math.ceil(step.details.distance_meters / WALK_SPEED / 60)
  const startLocation = buildDetailedLocation(step.details.start_location)
  const endLocation = !step.details.end_location
    ? null
    : buildDetailedLocation(step.details.end_location)

  const distance = {
    miles: Math.ceil(step.details.distance_miles * 100) / 100,
    meters: Math.ceil(step.details.distance_meters * 100) / 100,
  }

  if (endLocation) {
    return {
      from: {
        distance: 0,
        location: startLocation,
      },
      to: {
        distance: 0,
        location: endLocation,
      },
      type: STEP_TYPE.WALK,
      main: step.main,
      description: step.details.description || '',
      distance,
      accurateTime,
      departureDatetime: null,
      arrivalDatetime: null,
      provider: WALK_PROVIDER,
      vehicle: WALK_VEHICLE,
      passengersCount: 1,
      amenities: [],
      alternativeTimes: [],
      alternativeTimesIndex: -1,
      ticketTypes: [],
      passTypes: [],
      serviceHours: null,
      bookingDetails: WALK_BOOKING_DETAILS,
    }
  }

  throw new Error('The data provided do not allow to create a walking step')
}

export default buildWalkingStep
